/* c8 ignore start */
// This file is part of shadcn/ui and not counted in code coverage
import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
/* c8 ignore end */
